<form [formGroup]="titleForm" (ngSubmit)="submitted = true; validate()">
  <span style="display: flex;
    flex-direction: column;
    align-self: stretch;    margin-top: 20px;">
    <label for="title" class="text-start"> Name </label>
    <input pInputText [placeholder]="built?'Fulfillment title':'Response Name'" formControlName="nameAction" required>
    <mat-error *ngIf=" submitted && !titleForm.controls['nameAction'].value">
      required Name!
    </mat-error>
  </span>
  <div class="d-flex justify-content-between gap margTop24" style="gap: 12px; padding-bottom: 16px;">
    <div class="btn-default d-block w-100">
      <button [disabled]="isDisabled" type="button" class="w-100 d-flex justify-content-center"
        (click)="onCloseClick()">Cancel</button>
    </div>
    <div class="btn-1 d-block w-100">      
      <button [disabled]="isDisabled || isLoading" type="submit"
        class="w-100 d-flex justify-content-center align-items-center submit-button" [class.loading]="isLoading">
        <span *ngIf="isLoading" class="loading-content">
          <i class="pi pi-spin pi-spinner loading-spinner"></i>
          <span class="loading-text">Creating...</span>
        </span>
        <span *ngIf="!isLoading" class="button-text">{{ mode === 'update' ? 'Update' : 'Create' }}</span>
      </button>
    </div>
  </div>

</form>